/* ps-currency.js -- Primostore. Authored in the hub, not by Impulse.
   Rewrites the currency mark per locale. Shopify has one money format for the
   whole store (483 Admin API mutations, none of them sets it), so the mark is
   corrected in the rendered page instead: `ج` after the number in Arabic,
   `EGP` before it in English.
   Storefront only -- Shopify's hosted checkout is not ours to script. */
(function () {
  "use strict";

  var lang = (document.documentElement.getAttribute("lang") || "en").toLowerCase();
  var isAr = lang.indexOf("ar") === 0;

  /* `LE 1,370.00`, `LE 845.00 EGP`, `LE 70`. The trailing EGP comes from
     moneyWithCurrencyFormat and must be swallowed, or the rewrite would leave
     `845 ج EGP`. */
  var MONEY = /LE\s*([0-9][0-9,]*(?:\.[0-9]{2})?)(\s*EGP)?/g;
  /* Trailing marks too. The BOGOS free-shipping widget in the cart drawer
     renders `1250 LE` and `405.00 ج.م.` -- number FIRST -- so the leading
     pattern above never saw them and the drawer carried three different marks
     for one currency. */
  var MONEY_TRAIL = /([0-9][0-9,]*(?:\.[0-9]{2})?)\s*(?:LE\b|ج\.\s?م\.?)/g;

  function tidy(n) {
    /* Drop .00 -- every price here is whole pounds and the store's own copy
       reads `70 ج`. A genuine fractional price keeps its decimals. */
    return n.replace(/\.00$/, "");
  }

  function mark(n) {
    n = tidy(n);
    return isAr ? (n + " ج") : ("EGP " + n);
  }

  function rewrite(text) {
    return text
      .replace(MONEY, function (_m, amount) { return mark(amount); })
      .replace(MONEY_TRAIL, function (_m, amount) { return mark(amount); });
  }

  /* Never walk into these: script/style would corrupt code, and form fields
     hold values the shopper or the theme submits. */
  /* Cheap gate before the expensive walk. Not /g -- a global regex keeps
     lastIndex between calls and would skip every other match. */
  var HAS_MONEY = /LE\s*[0-9]|[0-9]\s*(?:LE\b|ج\.)/;

  var SKIP = {SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1,
              SELECT: 1, OPTION: 1, TEMPLATE: 1, CODE: 1, PRE: 1};

  function walk(root) {
    if (!root) { return; }
    if (root.nodeType === 3) { swap(root); return; }
    if (root.nodeType !== 1) { return; }
    if (SKIP[root.tagName]) { return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP[p.tagName]) { return NodeFilter.FILTER_REJECT; }
        return node.nodeValue && HAS_MONEY.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var batch = [], n;
    while ((n = w.nextNode())) { batch.push(n); }
    batch.forEach(swap);
  }

  function swap(node) {
    var before = node.nodeValue;
    if (!before || !HAS_MONEY.test(before)) { return; }
    var after = rewrite(before);
    if (after !== before) { node.nodeValue = after; }
  }

  function run() { walk(document.body); }

  if (document.readyState !== "loading") { run(); }
  else { document.addEventListener("DOMContentLoaded", run); }

  /* Prices are re-rendered on variant change, cart drawer opens, quantity
     edits and AJAX pagination. Without this the mark reverts to `LE` the
     moment anything updates -- which is most of the interesting moments. */
  if ("MutationObserver" in window) {
    var pending = null;
    new MutationObserver(function (records) {
      if (pending) { return; }
      pending = setTimeout(function () {
        pending = null;
        records.forEach(function (r) {
          if (r.type === "characterData") { swap(r.target); }
          else { Array.prototype.forEach.call(r.addedNodes, walk); }
        });
      }, 30);
    }).observe(document.documentElement,
               {childList: true, subtree: true, characterData: true});
  }
})();
